module.exports = __webpack_public_path__ + "img/bab10vite.af9f8810.png";